// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.meeting-action-menu-btn-tooltip .tooltip-inner {\n  background: rgba(24, 25, 27, 0.98);\n  border: 1px solid #4d4d4d;\n  border-radius: 6px;\n  padding: 6px 16px;\n  white-space: nowrap;\n  width: auto;\n  z-index: 100;\n  text-align: center;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: white;\n  font-weight: 600;\n  top: -35px;\n}\n", ""]);
// Exports
module.exports = exports;
